import { useToast as chakraUseToast } from '@chakra-ui/react';

interface IShowToast {
  type: 'error' | 'success' | 'warning';
  message?: string | undefined;
  [x: string]: any;
}

export const useToast = () => {
  const toast = chakraUseToast();

  const showToast = ({ type, message, ...restOptions }: IShowToast): void => {
    toast({
      description: message,
      status: type || 'error',
      duration: 9000,
      isClosable: true,
      position: 'bottom-right',
      ...restOptions,
    });
  };

  return { showToast };
};
